/**
 * ヘッダーのスクロール連動。
 * - 下スクロールでフェードアウト、上スクロールでフェードイン（PC / SP）
 * - TOP の FV 上ではユーティリティアイコンを隠し、カード上端が画面最上端に達したら出す（PC のみ）
 * - ユーティリティは一度出したら、FV に戻っても出したまま（ヘッダー全体の表示切替とは独立）
 *
 * theme.js の Header（hide-on-scroll）には依存しない。
 */
(function () {
  var FADE_THRESHOLD_PX = 50;
  var PC_MIN_WIDTH = 1000;
  var UTILITY_SELECTOR = '.header__utility-link';
  var CARDS_SELECTOR = '.top-prism-section__cards';
  var HEADER_SELECTOR = '.header';

  var header = null;
  var cardsRoot = null;
  var pcMedia = null;
  var scrollPrev = 0;
  var isHeaderVisible = true;
  var isUtilitiesVisible = null;
  var utilitiesHaveAppeared = false;
  var rafId = 0;
  var started = false;

  function getScrollY() {
    return Math.max(0, window.scrollY || window.pageYOffset || 0);
  }

  function isOverlayOpen() {
    if (!header) return false;

    if (header.querySelectorAll(':where(.header__primary-nav, .header__secondary-nav) [open]').length > 0) {
      return true;
    }

    if (header.querySelector('header-search[open], .header-search[open]')) {
      return true;
    }

    if (document.querySelector('#sidebar-menu[open], header-sidebar[open]')) {
      return true;
    }

    return false;
  }

  function setHeaderVisible(visible) {
    if (!header || visible === isHeaderVisible) return;
    if (!visible && isOverlayOpen()) return;

    isHeaderVisible = visible;
    header.classList.toggle('is-hidden', !visible);
    document.documentElement.style.setProperty('--header-is-visible', visible ? '1' : '0');
  }

  function onScrollTick() {
    rafId = 0;
    if (!header) return;

    if (header.hasAttribute('data-header-scroll-fade')) {
      var scrollY = getScrollY();

      if (scrollPrev > scrollY) {
        setHeaderVisible(true);
      } else if (scrollPrev < scrollY && scrollY > FADE_THRESHOLD_PX && isHeaderVisible) {
        setHeaderVisible(false);
      }

      scrollPrev = scrollY;
    }

    syncUtilitiesFromCardsPosition();
  }

  function onScroll() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(onScrollTick);
  }

  function isPc() {
    return pcMedia ? pcMedia.matches : window.matchMedia('(min-width: ' + PC_MIN_WIDTH + 'px)').matches;
  }

  function syncUtilityAccessibility(isVisible) {
    if (!header) return;

    var hideFromKeyboard = isPc() && cardsRoot && !isVisible;
    var items = header.querySelectorAll(UTILITY_SELECTOR);

    items.forEach(function (item) {
      var controls = item.querySelectorAll('a, button');

      if (hideFromKeyboard) {
        item.setAttribute('aria-hidden', 'true');
        controls.forEach(function (control) {
          control.setAttribute('tabindex', '-1');
        });
        return;
      }

      item.removeAttribute('aria-hidden');
      controls.forEach(function (control) {
        control.removeAttribute('tabindex');
      });
    });
  }

  function setUtilitiesVisible(isVisible) {
    if (!header) return;

    if (!isPc() || !cardsRoot) {
      isVisible = true;
    }

    if (isUtilitiesVisible === isVisible) return;

    isUtilitiesVisible = isVisible;
    header.classList.toggle('is-utilities-visible', isVisible);
    syncUtilityAccessibility(isVisible);
  }

  function syncUtilitiesFromCardsPosition() {
    if (!header) return;

    cardsRoot = document.querySelector(CARDS_SELECTOR);

    if (!isPc() || !cardsRoot) {
      setUtilitiesVisible(true);
      return;
    }

    if (utilitiesHaveAppeared) {
      setUtilitiesVisible(true);
      return;
    }

    var shouldShow = cardsRoot.getBoundingClientRect().top <= 0;
    if (shouldShow) {
      utilitiesHaveAppeared = true;
    }
    setUtilitiesVisible(shouldShow);
  }

  function onPcMediaChange() {
    syncUtilitiesFromCardsPosition();
  }

  function bind() {
    if (started) return;

    header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    started = true;
    scrollPrev = getScrollY();
    pcMedia = window.matchMedia('(min-width: ' + PC_MIN_WIDTH + 'px)');

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (pcMedia.addEventListener) {
      pcMedia.addEventListener('change', onPcMediaChange);
    } else if (pcMedia.addListener) {
      pcMedia.addListener(onPcMediaChange);
    }

    syncUtilitiesFromCardsPosition();
  }

  function unbind() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);

    if (pcMedia) {
      if (pcMedia.removeEventListener) {
        pcMedia.removeEventListener('change', onPcMediaChange);
      } else if (pcMedia.removeListener) {
        pcMedia.removeListener(onPcMediaChange);
      }
    }

    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = 0;
    }

    started = false;
    header = null;
    cardsRoot = null;
    pcMedia = null;
    isUtilitiesVisible = null;
    utilitiesHaveAppeared = false;
  }

  function onSectionLoad(event) {
    if (!event.target) return;
    if (
      !event.target.classList.contains('shopify-section--header') &&
      !event.target.classList.contains('shopify-section--top-prism')
    ) {
      return;
    }
    unbind();
    bind();
  }

  function onSectionUnload(event) {
    if (!event.target || !event.target.classList.contains('shopify-section--header')) return;
    unbind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
